import React from 'react';
import { OrdersTab as SharedOrdersTab } from '@ubeya/shared-web/components';
import { useClientOrders } from '@ubeya/shared/hooks/account/useClientOrders';

export const OrdersTab = ({ clientId, onOpenOrderDetails }) => {
  const { data = [], isLoading } = useClientOrders(clientId);

  return <SharedOrdersTab data={data} isLoading={isLoading} onOpenOrderDetails={onOpenOrderDetails} />;
};
